import React from 'react';
import './LoadingSpinner.css';

const GameLoadingFallback = () => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-content">
        <div className="spinner-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <h3 className="loading-title">🎮 Cargando el Juego</h3>
        <p className="loading-message">Ayuda a Dani & Ana a llegar a la iglesia...</p>
        <p style={{ fontSize: '0.85rem', color: '#999', marginTop: '0.5rem' }}>
          Esto puede tomar un momento
        </p>
      </div>
    </div>
  );
};

export default GameLoadingFallback;
